export default __webpack_public_path__ + "static/media/pizza.a64c0d3f.jpg";